import FeatureFlagsProvider from './feature.flags.provider'

export default FeatureFlagsProvider
